/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Types of metadata that can be requested for playback content.
 * Used to specify which metadata to fetch via IMetadataModel.prepareMetadataByType().
 */
export enum MetadataType {
  /**
   * Detailed information about a specific action (e.g., watch action details).
   */
  ACTION_DETAILS = "ACTION_DETAILS",

  /**
   * List of available actions for the content.
   */
  ACTION_LIST = "ACTION_LIST",

  /**
   * Current airing information for linear content.
   */
  AIRING = "AIRING",

  /**
   * Request to delete a recording.
   */
  DELETE_RECORDING = "DELETE_RECORDING",

  /**
   * Full preview information with extended details.
   */
  FULL_INFO_PREVIEW = "FULL_INFO_PREVIEW",

  /**
   * Last viewed position for NDVR content.
   */
  NDVR_LAST_VIEWED_POSITION = "NDVR_LAST_VIEWED_POSITION",

  /**
   * Basic preview information for the content.
   */
  PREVIEW = "PREVIEW",

  /**
   * Action list specific to recordings.
   */
  RECORDING_ACTION_LIST = "RECORDING_ACTION_LIST",

  /**
   * Action list for VOD content.
   */
  VOD_ACTION_LIST = "VOD_ACTION_LIST"
}
